import React, { Suspense, lazy } from 'react'
import ReactDOM from 'react-dom'
import Collection from './generic/collection'
import { getCfg } from "./utils/getCfg"
import { makeRequest } from './utils/makeRequest'
import Loader from '../components/calculator/components/loader'
import Modals from './modals'
import CatalogFilter from './catalogFilter'

const App = lazy(() => import(/* webpackChunkName: "Calculator" */"../components/calculator/App"))

export const instance = '[data-js-calculator]'

export class Calculator {

  constructor (instance) {
    this.instance = instance
    this.init()
  }

  render(isLoading = true) {
    ReactDOM.render(
      isLoading ? <Loader/> :
      <Suspense fallback={<Loader/>}>
        <App {...this.cfg} />
      </Suspense>, this.instance
    )
  }

  async getData() {
      return makeRequest({ url: this.cfg.url })
        .then(({ success, data, errors }) => {
          if (success) {
            return data
          } else {
            return Promise.reject(errors)
          }
        })
  }

  init() {
    this.render()
    this.cfg = getCfg(this.instance, CalculatorCollection.els.instance, CalculatorCollection.defaultCfg);
    this.getData()
      .then((data) => {
        this.cfg.data = data
        this.render(false)
      })
      .catch((e) => {
        $.fancybox.close()
        $.fancybox.open({
          src: '#modal-error',
          type: 'inline'
        })
      console.debug('Failed to get data: ', e)
    })
  }
}

export class CalculatorCollection extends Collection {
  static els = {
    instance,
    modalId: '#modal-calculator',
    modalBtn: '[data-js-modal-calculator-template]'
  }
  static defaultCfg = { baseClass: "Calculator", localeKey: CalculatorCollection.els.instance }

  constructor() {
    super(instance, Calculator)
    this.bindEvents()
    this.init()
  }
  bindEvents() {
    document.querySelectorAll(CalculatorCollection.els.modalBtn).forEach((el) => {
      el.addEventListener('click', (e) => this.handleButtonClick(e))
    })

    document.addEventListener(CatalogFilter.bubbles.newCatalogTable, (e) => {
      e.detail.querySelectorAll(CalculatorCollection.els.modalBtn).forEach((el) => {
        el.addEventListener('click', (e) => this.handleButtonClick(e))
      })
    })
  }
  handleButtonClick(e) {
    e.preventDefault()
    Modals.openAjaxModal(e.currentTarget.href)
  }
  init(context = document) {
    context.querySelectorAll(instance).forEach((el) => {
      this.collection = new Calculator(el)
    })
  }
}
